// extracted by mini-css-extract-plugin
export var HeroContainer = "Hero-module--HeroContainer--HnquY";
export var Home = "Hero-module--Home--3fDsc";
export var Page = "Hero-module--Page--3q600";